import React from 'react';
import { DropDown } from './common';
import {validatable} from 'components/utils';
import {DuLieuHeThong} from 'api';

class DropDownChonDonViTTXM extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state={
      data: []
    }
  }

  onChange(e) {
    this.props.onChange(e);
  }

  componentDidMount() {
    this.getData(this.props.loaiDon)
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.loaiDon != nextProps.loaiDon) {
      this.getData(nextProps.loaiDon)
    }
  }

  getData(loaiDon) {
    let params = {
      loaiDon: loaiDon ? loaiDon : null
    }
    DuLieuHeThong.actions.getDonViTTXMNew.request('', params).then(res => {
      if (res.data._embedded) {
        this.setState({
          data: res.data._embedded ? res.data._embedded.coQuanQuanLies : []
        })
      }
    })
  }

  render() {
    let lb1 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'thẩm tra xác minh';
    return (
      <DropDown
        label={"Đơn vị "+lb1}
        bindValidator={this}
        channel="formTaoDon"
        selectedValue={this.props.selectedValue}
        require={this.props.require}
        isValid={this.props.isValid}
        options={this.state.data}
        keyName='coQuanQuanLyId' valueName='ten'
        onChange={this.onChange.bind(this)}
        placeholder={this.props.placeholder}
        className={'col-input '+this.props.className} name={this.props.name}/>
    )
  }
}

DropDownChonDonViTTXM.defaultProps = {
  className: 'input-group',
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  require: false,
  isValid: false,
  name:''
}


export default validatable(DropDownChonDonViTTXM);



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-chondonviTTXM.jsx